import { useCallback, useEffect, useState } from "react";

import * as m from "@bokio/mobile-web-shared/core/model/model";

import {
	defaultContextValue,
	NotificationActivityContext,
	notificationActivityHub,
} from "./NotificationActivityContext";

import type { NotificationActivityState } from "./NotificationActivityContext";
import type { FC, PropsWithChildren } from "react";

export const NotificationActivityProvider: FC<PropsWithChildren> = props => {
	const [state, setState] = useState<NotificationActivityState>(defaultContextValue);

	const onMessage = useCallback((message: m.Core.Services.Notifications.Dtos.NotificationWebActivityDto) => {
		setState(prev => ({
			badgeCount: message.BadgeCount,
			activityCounter: {
				eInvoices:
					prev.activityCounter.eInvoices +
					(message.AreaType === m.Entities.Notifications.NotificationAreaType.IncomingEInvoice ? 1 : 0),
			},
		}));
	}, []);

	useEffect(() => {
		notificationActivityHub.add(onMessage);

		return () => {
			notificationActivityHub.remove(onMessage);
		};
	}, [onMessage]);

	return <NotificationActivityContext value={state}>{props.children}</NotificationActivityContext>;
};
